<template>
  <div class="boss-interview-candidate-date-schedules-wrap">
    <interview-candidate-date-schedule
      v-for="(schedule, i) in schedules"
      :key="`schedule-${i}`"
      class="boss-interview-candidate-date-schedule"
      :is-publishing="isPublishing"
      :is-linked-job="isLinkedJob(schedule.id)"
      :schedule="schedule"
      :data-test="`interview-candidate-date-schedule-${i}`"
    />
    <div
      v-for="(schedule, i) in schedules"
      :key="`schedule-adjuster-${i}`"
      :data-test="`schedule-adjuster-${i}`"
      class="boss-interview-candidate-date-schedule-adjuster"
    />
  </div>
</template>

<script>
import InterviewCandidateDateSchedule from '@/components/molecules/InterviewCandidateDateSchedule'

export default {
  components: { InterviewCandidateDateSchedule },
  props: {
    schedules: {
      type: Array,
      required: true
    },
    jobs: {
      type: Array,
      required: true
    }
  },
  computed: {
    isPublishing () { return this.jobs.length > 0 }
  },
  methods: {
    isLinkedJob (scheduleId) {
      return this.jobs.some(job => job.scheduleId === scheduleId)
    }
  }
}
</script>
